<div class="tw-cursor-help tw-flex tw-gap-1" container="body" [ngbTooltip]="deviceService.iconTooltip(device)"
      [placement]="tooltipPlacement ? tooltipPlacement : 'right'">
  <sb-icon *ngIf="deviceService.icon(device)" [icon]="deviceService.icon(device)"
             [ngClass]="deviceService.iconColor(device)"></sb-icon>
    <span [ngClass]="deviceService.iconColor(device)">{{deviceService.iconText(device)}}</span>
    <span *ngIf="device?.serviceRequest" [ngClass]="deviceService.iconColor(device)">&nbsp;Service!</span>
</div>
